// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1JrUF","noInteraction":"EventWrapper_noInteraction__12Bhb","pointerPassthrough":"EventWrapper_pointerPassthrough__3bDYs"};